<template>
    <button :disabled="disabled" :style="{float:(pull?pull:'none')}" :class="{active:active,disabled:disabled, btn:true,[config.type]:true,[config.size]:true, 'mobile-version':isMobile}" @click="onClick" @touchstart="onTouchStart">
        <span v-if="config.icon || config.iconSvg">
            <span :class="`fal fa-${config.icon}`" :style="{fontSize:config.iconSize+'px'}" v-if="config.iconRight != ''"></span>
            <span v-if="config.label"  :style="{textTransform:lcase?lcase:''}">&nbsp;{{config.label}}&nbsp;&nbsp;</span>
            <span :class="`fal fa-${config.icon}`" :style="{fontSize:config.iconSize+'px'}" v-if="config.iconRight === ''"></span>
        </span>
        <span v-else :style="{textTransform:lcase?lcase:''}">{{config.label}}</span>
        <slot />
    </button>
</template>
<script>
import Icon from "./icon.vue";
export default {
    props: {
        'label': { type: [String, Object] },
        'm': String,
        'type': { type: String },
        'size': { type: String },
        "icon": String,
        "lcase": String,
        "iconSvg": String,
        "iconSize": {
            type: Number,
            default: 14
        },
        "iS": String,
        "iSz": String,
        "iconRight": String,
        "modal-open": String,
        "l": [String, Object],
        "t": { type: String, default: 'p' },
        "s": { type: String, default: 's' },
        "i": String,
        "pull": String,
        "disabled": Boolean,
        "active": Boolean,
        "iR": {
            type: String,
            default: "false"
        },
        "modalClose": String,
        "pressValue": {
            type: [String, Number],
            default: "define thin value by 'pressValue' prop"
        },
    },

    components: { Icon },
    mounted() {
        if (!this.press) {

        }
    },
    template: `#button-template`,
    methods: {
        onClick(e) {
            //if(this.m !== ''){
            if (this.modalOpen && this.modalOpen !== '') {
                this.$store.commit('modalOpen', this.modalOpen);
            }
            if (this.modalClose) {
                this.$store.commit('modalClose', this.modalClose);

            }
            this.$emit('press', e);
            // }

        },
        onTouchStart(e) {
            if (this.m === '') {
                // this.$emit('press', e);
            }
        }
    },

    data() { return {} },
    computed: {
        isMobile() {
            return this.m === "";
        },
        config() {
            let convert = {
                "l": "label",
                "t": {
                    to: "type",
                    convert: {
                        p: "primary",
                        s: "success",
                        i: "info",
                        d: "danger",
                        df: "default",
                        w: "warning"
                    }
                },
                "s": {
                    to: "size",
                    convert: {
                        xs: "extraSmall",
                        s: "small",
                        m: "medium",
                        l: "large",
                        xl: "extraLarge"
                    }
                },
                "i": "icon",
                "iR": "iconRight",
                "iS": "iconSvg",
                "iSz": "iconSize"
            };
            let newProps = {};
            Object.keys(convert).map((shortProp) => {
                let longProp = convert[shortProp];
                let toProp = longProp;
                if (typeof longProp === "object") {
                    toProp = longProp.to;

                    if (longProp.convert) {
                        if (!this[toProp]) {
                            newProps[toProp] = longProp.convert[this[shortProp]];
                        } else {
                            newProps[toProp] = this[toProp];
                        }
                    }
                } else {
                    if (!this[toProp]) {
                        newProps[toProp] = this[shortProp];
                    } else {
                        newProps[toProp] = this[toProp];
                    }
                }
            });
            //console.log(newProps);
            return newProps;
        },
        classes() {
            let sizes = {
                "sz-xs": "extraSmall",
                "sz-s": "small",
                "sz-m": "medium",
                "sz-l": "large",
                "sz-xl": "extraLarge"
            };
            return "";
        }
    }
};
</script>
<style>
    
.btn-group {
    padding: 2px 0;
    display: inline-block;
    margin:0 2px;
}
</style>
<style scoped>
.btn .fa {
    /*vertical-align: middle;*/
}

.btn.small :global .fa {}

.btn.icon {
    padding: 2px 4px;
}

.btn {
    border: 1px solid lightgrey;
    padding: 2px 12px;
    border-radius: 3px;
    display: inline-block;
    cursor: pointer;
    background: white;
    /*margin:2px;*/
    font-size: 12px;
    text-align: center;
    user-select: none;
    font-weight: 400;
    outline: none;
    color: white;

    box-sizing: border-box;


    text-shadow: 0 -1px 0 rgba(0, 0, 0, .2);
    -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(0, 0, 0, .075);
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(0, 0, 0, .075);
}

.btn:active {
    -webkit-box-shadow: inset 0 3px 5px rgba(0, 0, 0, .125);
    box-shadow: inset 0 3px 5px rgba(0, 0, 0, .125);
    outline: none;

}

.btn.extraSmall {
    padding: 1px 2px 0px;
    margin: 1px;
    border-radius: 2px;
    min-width: 10px;
}

.btn.small {
    padding: 4px 8px;
    margin: 2px 2px 2px 2px;
    border-radius: 2px;
    font-size: 12px;
}

.btn.medium {
    padding: 6px 10px;
    margin: 3px 2px 3px 2px;
    border-radius: 2px;
    font-size: 14px;
}

.btn.large {
    padding: 8px 12px;
    margin: 4px 2px 4px 2px;
    border-radius: 2px;
    font-size: 16px;
}

.btn.extraLarge {
    padding: 10px 14px;
    border-radius: 2px;
    font-size: 18px;
}










.btn.danger {
    background-image: -webkit-linear-gradient(top, #d9534f 0, #c12e2a 100%);
    background-image: -o-linear-gradient(top, #d9534f 0, #c12e2a 100%);
    background-image: -webkit-gradient(linear, left top, left bottom, from(#d9534f), to(#c12e2a));
    background-image: linear-gradient(to bottom, #d9534f 0, #c12e2a 100%);
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffd9534f', endColorstr='#ffc12e2a', GradientType=0);
    filter: progid:DXImageTransform.Microsoft.gradient(enabled=false);
    background-repeat: repeat-x;
    border-color: #b92c28;
    color: white;
}

.btn.danger:hover {
    background-color: #c12e2a;
    border-color: #b92c28;
    background-position: 0 -21px;
}

.btn.danger:active,
.btn.danger.active {
    background-color: #ac2925;
    border-color: #761c19;
}

.switchGroup {
    display: inline-block;
}

.btn.success {
    background-image: -webkit-linear-gradient(top, #5cb85c 0, #419641 100%);
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff5cb85c', endColorstr='#ff419641', GradientType=0);
    filter: progid:DXImageTransform.Microsoft.gradient(enabled=false);
    background-repeat: repeat-x;
    border-color: #3e8f3e;
    color: white;
}

.btn.success:hover {
    background-color: #419641;
    background-position: 0 -21px;
    border-color: #398439;
}

.btn.success:active,
.btn.success.active {
    background-color: #419641;
    border-color: #3e8f3e;
}


.btn.success:focus {
    /*box-shadow: 0 0 0 2px rgba(0, 134, 29, 0.5);*/
}

.btn.primary {
    color: #fff;

    background-image: -webkit-linear-gradient(top, #337ab7 0, #265a88 100%);
    background-image: -o-linear-gradient(top, #337ab7 0, #265a88 100%);
    background-image: -webkit-gradient(linear, left top, left bottom, from(#337ab7), to(#265a88));
    background-image: linear-gradient(to bottom, #337ab7 0, #265a88 100%);
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff337ab7', endColorstr='#ff265a88', GradientType=0);
    filter: progid:DXImageTransform.Microsoft.gradient(enabled=false);
    background-repeat: repeat-x;
    border-color: #245580
}

.btn.primary:hover {
    background-color: #265a88;
    background-position: 0 -15px
}

.btn.primary:focus {
    /*box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.5);*/
}

.btn.primary.disabled {
    background-color: lightgrey;
    border-color: grey;
}

.btn.primary:active,
.btn.primary.active {
    background-color: #265a88;
    border-color: #245580
}




.btn.warning {
    color: #fff;
    background-color: #f0ad4e;
    border-color: #eea236;
}

.btn.warning:hover {
    color: #fff;
    background-color: #ec971f;
    border-color: #d58512;
}

.btn.info {
    background-image: linear-gradient(to bottom, #5cabb8 0%, #417b96 100%);
    background-repeat: repeat-x;
    border-color: #3e768f;
    color: white;
}

.btn.info:hover {
    background-color: #416e96;
    background-position: 0 -21px;
    border-color: #396984;
}

.btn.info:active,
.btn.info.active {
    background-color: #417696;
    border-color: #3e608f;
}





.btn-group .btn {
    display: inline-block;
    border-radius: 2px;
}

.btn-group .btn:first-child {
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
    margin-left: 0px;
}

.btn-group .btn:last-child {
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
    margin-left:-3px;
}

.btn.active,
.btn:active {
    /*    background:linear-gradient(to bottom, #6ab1f7, #1b82fb);
    border-top-color:#51a4f6;
    border-left-color:#388df9;
    border-right-color:#388df9;
    border-bottom-color: #3077ff;
*/
    -webkit-box-shadow: inset 0 3px 5px rgba(0, 0, 0, .125);
    box-shadow: inset 0 3px 5px rgba(0, 0, 0, .125);
}

.btn-group-vertical .btn:first-child {
    margin-top: 0;
    border-top-left-radius: 2px;
    border-top-right-radius: 2px;
}

.btn-group-vertical .btn:last-child {
    border-bottom-left-radius: 2px;
    border-bottom-right-radius: 2px;
}

.btn-group-vertical .btn {
    display: block;
    margin-top: -2px;
    border-radius: 0;
    width: 100%;
}

.btn.disabled,
.btn.disabled:hover,
.btn.disabled:active,
.btn.disabled.active {
    cursor: not-allowed;
    background: lightgrey;
    border-color: lightgrey
}

.mobile-version {
    display: block;
    width: 100%;
}

.btn.default {
    color: #444;
}
</style>